// - Headers
import moment from 'moment'

export default [
    {
        text: 'N°',
        fieldType: 'computed',
        computed: ({ id }) => id,
        sortable: false, //campo que puede ser ordenado desde Maestros del Backend, se debe solicitar qué campo ordenar
    },
    {
        text: 'Supervisor',
        fieldType: 'computed',
        computed: ({ supervisor_g_user }) =>
            supervisor_g_user.hr_employee.names +
            ' ' +
            supervisor_g_user.hr_employee.last_name1 +
            ' ' +
            supervisor_g_user.hr_employee.last_name2,
        sortable: false,
    },
    {
        text: 'Fecha creación',
        fieldType: 'computed',
        computed: ({ creation_date }) => {
            if (creation_date && creation_date !== null) {
                return moment(creation_date.substr(0, 10), 'YYYY-MM-DD').format('DD-MM-YYYY')
            } else {
                return 'Sin definir'
            }
        },
        sortable: false,
    },
    {
        text: 'Estado',
        fieldType: 'computed',
        computed: ({ g_state }) => g_state.state,
        // sortable: false,
    },
]
